import { awsApiRequest } from '.';
import moment from "moment";

const awsApiType = Object.freeze({
  CGCO: 'CGCO',
  NAGCO: 'NAGCO',
  GATE: 'GATE',
  SFTP_REC_TYPE: 'SftpRecType',
  SFTP_REC_LOG: 'SftpRecLog'
});

export const getProducts = (cb) => {
  awsApiRequest(
    {
      endpoint: '/product',
      apiName: awsApiType.CGCO,
    },
    cb);
};

export const getOrderDiscounts = (id, cb) => {
  awsApiRequest(
    {
      endpoint: `/orderdiscounts/${id}`,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const getCalculatedDiscounts = (discountableItems, cb) => {
  awsApiRequest(
    {
      endpoint: '/discountrates/calculate',
      method: 'POST',
      payload: discountableItems,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const createOrder = (order, cb) => {
  awsApiRequest(
    {
      endpoint: '/order',
      method: 'POST',
      payload: order,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const getOrderById = (id, cb) => {
  awsApiRequest(
    {
      endpoint: `/order`,
      params: { orderId: id },
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const updateOrder = (id, order, cb) => {
  awsApiRequest(
    {
      endpoint: `/order/${id}`,
      method: 'PUT',
      payload: order,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const getOrderHistory = (orderId, cb) => {
  awsApiRequest(
    {
      endpoint: `/orderhistory/${orderId}`,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const updateOrderHistory = (orderHistory, cb) => {
  awsApiRequest(
    {
      endpoint: `/orderhistory`,
      method: 'POST',
      payload: orderHistory,
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const resendEmail = (id, reEmail, cb) => {
  awsApiRequest(
    {
      endpoint: `/order/email`,
      method: 'POST',
      payload: {
        orderId: id,
        emailTemplate: "Template-Order-Confirmation",
        emailAddress: reEmail
      },
      apiName: awsApiType.NAGCO,
    },
    cb);
};

export const fetchOrdersWithFilters = (filters, cb) => {
  const { 
    keyword, 
    fromDate, 
    toDate, 
    status, 
    size, 
    nextToken, 
    orderStart, 
    orderEnd, 
    orderAt, 
    previous } = filters;
  const params = {};
  if (keyword) params.query = keyword.trim();
  if (fromDate) params.dateFrom = moment(fromDate).toISOString();
  if (toDate) params.dateTo = moment(toDate).endOf('day').toISOString();
  if (status && Number(status) !== 0) params.orderStatus = status;
  if (size) params.pageSize = size;
  if (nextToken) params.nextToken = nextToken;
  if (orderStart) params.orderStart = orderStart;
  if (orderEnd) params.orderEnd = orderEnd;
  if (orderAt) params.orderAt = orderAt;
  if (previous) params.previous = previous;
  awsApiRequest(
    {
      endpoint: '/order/search',
      apiName: awsApiType.NAGCO,
      params
    }, cb);
};

export const issueLogEntry = (issueLogEntry, cb) => {
  awsApiRequest(
    {
      endpoint: '/issuelog',
      method: 'POST',
      payload: issueLogEntry,
      apiName: awsApiType.GATE,
    },
    cb);
};

export const getIssueLogConfig = (cb) => {
  awsApiRequest(
    {
      endpoint: '/issuelogconfig',
      apiName: awsApiType.GATE,
    },
    cb);
};

export const getReportTypes = (userEmail, cb) => {
  awsApiRequest(
    {
      endpoint: `/${userEmail}`,
      method: 'GET',
      apiName: awsApiType.SFTP_REC_TYPE,
    }, cb);
};

export const getReportFiles = (type, from, to, cb) => {
  awsApiRequest(
    {
      endpoint: `/type/${type}`,
      method: 'GET',
      params: { dateFrom: from, dateTo: to },
      apiName: awsApiType.SFTP_REC_LOG,
    }, cb);
};

export const getReportFile = (id, cb) => {
  awsApiRequest(
    {
      endpoint: `/${id}`,
      method: 'GET',
      apiName: awsApiType.SFTP_REC_LOG,
    }, cb);
};

export const exportOrders = ({ fromDate, toDate, status, keyword }, cb) => {
  const params = {};
  if (keyword) params.query = keyword.trim();
  if (fromDate) params.dateFrom = moment(fromDate).format("YYYY-MM-DD");
  if (toDate) params.dateTo = moment(toDate).format("YYYY-MM-DD");
  if (status && Number(status) !== 0) params.orderStatus = status;
  params.format = 'csv';
  awsApiRequest(
    {
       endpoint: '/order/search',
       responseType: 'csv',
       apiName: awsApiType.NAGCO,
      params
    },
    cb);
};

export const getMarketingSources = (cb) => {
  awsApiRequest(
    {
      endpoint: '/marketingsources',
      apiName: awsApiType.NAGCO,
    },
    cb);
};